import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {
  MdOutlineErrorOutline,
  MdOutlineCheckCircle,
  MdOutlineClose,
} from 'react-icons/md';
import './AppAlert.scss';

function AppAlert({
  title,
  description,
  variant,
  showIcon,
  autoHideTime,
  onHide,
}) {
  const [show, setShow] = useState(true);

  const handleHide = () => {
    setShow(false);
    onHide();
  };

  useEffect(() => {
    setTimeout(handleHide, autoHideTime);
  }, []);

  if (!show) return null;

  return ReactDOM.createPortal(
    <div className="app-alert">
      {variant === 'success' && showIcon && (
        <MdOutlineCheckCircle className="app-alert__icon-success" />
      )}
      {variant === 'error' && showIcon && (
        <MdOutlineErrorOutline className="app-alert__icon-error" />
      )}
      {variant === 'warning' && showIcon && (
        <MdOutlineErrorOutline className="app-alert__icon-warning" />
      )}
      <div className={`app-alert__${variant}`}>
        <h2 className={`app-alert__${variant}_title`}>{title}</h2>
        <p className={`app-alert__${variant}_description`}>{description}</p>
      </div>
      <MdOutlineClose className="app-alert__icon-close" onClick={handleHide} />
    </div>,
    document.body,
  );
}

AppAlert.defaultProps = {
  title: '',
  description: '',
  showIcon: false,
  autoHideTime: 10000,
  onHide: () => {},
};

AppAlert.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  autoHideTime: PropTypes.number,
  variant: PropTypes.string.isRequired,
  showIcon: PropTypes.bool,
  onHide: PropTypes.func,
};

export default AppAlert;
